import { TumbleDryerOffIcon } from './TumbleDryerOffIcon';

/**
 * author: Michael Irigoyen
 * id E9DC2320-5FD4-403B-8445-9EB68B4468B6
 * name tumble-dryer-off
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tumble-dryer-off.svg
 * tags
 * - Home Automation 
 */
export const LaundryRoomOffIcon = TumbleDryerOffIcon;
export default LaundryRoomOffIcon